import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs'; // For newer Angular versions, otherwise uses toPromise

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: any = null;

  constructor(private http: HttpClient) {}

  public loadConfig(): Promise<void> {
    // ניתן לשנות כאן כדי לטעון קובץ לפי הסביבה או הדומיין
    // לדוגמה: return this.http.get(`assets/config/${location.hostname}.json`)...
    return firstValueFrom(this.http.get('assets/config.json'))
      .then((config: any) => {
        this.config = config;
        // console.log('Configuration loaded successfully', config);
      })
      .catch((err: any) => {
        console.error('Could not load configuration file', err);
        // במקרה של שגיאה, אפשר להגדיר ערכי ברירת מחדל או לזרוק שגיאה
        // this.config = { ...defaults };
      });
  }

  // פונקציה לשליפת הגדרות מתוך הקוד
  public get(key: string): any {
    if (!this.config) {
      throw Error('Config file not loaded!');
    }
    return this.config[key];
  }

  // גישה לכל האובייקט
  public getConfig(): any {
    return this.config;
  }
}

export function appConfigFactory(configService: AppConfigService) {
  return () => configService.loadConfig();
}
